<template>
  <b-input-group class="search-input-group">
    <b-input-group-prepend v-if="isSearching" class="folder-name-prepend">
      <span class="folder-name" :aria-label="folderName">{{ folderName }}</span>
      <span>:</span>
    </b-input-group-prepend>
    <b-input
      class="search-input"
      :class="isSearching ? 'pl-1' : ''"
      type="text"
      :value="value"
      :placeholder="placeholder"
      :aria-label="placeholder"
      @input="handleInput"
      @keyup.enter="handleEnterKey"
    />
    <b-input-group-append class="addons">
      <span
        v-if="isSearching"
        class="icon-Aula_close"
        tabindex="0"
        :aria-label="$getText('ARIA_LABEL_CLEAR_SEARCH')"
        @click="resetSearch()"
      />
      <span class="icon-Aula_search" @click="emitSelected" />
      <span
        class="icon-aula-advanced-search filter-icon d-inline-block"
        :class="{ 'is-advanced-search-active': searchModel.getIsUsingAdvancedSearch() }"
        role="button"
        tabindex="0"
        @keyup.enter="emitAdvancedSearchShow"
        @keyup.space="emitAdvancedSearchShow"
        @click="emitAdvancedSearchShow"
      />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { types } from '../../store/types/types';
import { mapGetters } from 'vuex';
import { messageProviderKeyEnum } from '../../../shared/enums/messageProviderKeyEnum';

export default {
  inject: {
    getSearchModel: messageProviderKeyEnum.SEARCH_MODEL,
  },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    folderName: { type: String },
  },
  data() {
    return {
      debounceTimeout: null,
    };
  },
  computed: {
    ...mapGetters({
      messageSearchQuery: types.MESSAGES_GET_ACTIVE_SEARCH_QUERY,
    }),
    searchModel() {
      return this.getSearchModel();
    },
    isSearching() {
      return this.value !== '' || this.searchModel.getIsUsingAdvancedSearch();
    },
  },
  watch: {
    messageSearchQuery() {
      this.updateValueInput(this.messageSearchQuery);
    },
  },
  methods: {
    resetSearch() {
      this.updateValueInput('');
      this.$emit('resetSearch', '');
    },
    updateValueInput(value) {
      this.$emit('updateValueInput', value);
    },
    resetSearchWithoutUpdate() {
      this.updateValueInput('');
    },
    emitSelected() {
      this.$emit('selected', this.value);
    },
    emitAdvancedSearchShow() {
      this.$emit('advanceSearchClick');
    },
    handleInput(val) {
      this.updateValueInput(val);
      this.$emit('inputChanged', val);
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.emitSelected();
      }, 1000);
    },
    handleEnterKey() {
      clearTimeout(this.debounceTimeout);
      this.emitSelected();
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.search-input-group {
  --input-padding-right: 120px;

  .form-control {
    border-radius: 0;

    &:focus-visible {
      outline: none;
    }
  }

  .icon-Aula_search {
    font-size: 22px;
    cursor: pointer;
  }

  .filter-icon {
    font-size: 22px;
    cursor: pointer;
    margin-left: 10px;

    &.is-advanced-search-active {
      color: var(--color-primary-dark);
      font-weight: bold;
    }
  }

  .icon-Aula_close {
    font-size: 14px;
    margin-top: 5px;
    margin-right: 10px;
    cursor: pointer;
  }

  .input-group-prepend {
    position: unset !important;
  }

  .input-group-append {
    position: absolute;
    right: 15px;
    top: var(--padding-top, 15px);

    .icon-Aula_edit_pen,
    .icon-Aula_search,
    .icon-tag {
      cursor: pointer;
    }
  }

  .addons {
    z-index: 100;
  }

  .folder-name-prepend {
    max-width: 42%;
    background-color: var(--color-white);
    padding: 15px 0 12px 20px;

    .folder-name {
      font-size: 14px;
      font-weight: 400;
      color: var(--color-primary-darker);
      user-select: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span:last-child {
      margin-top: -1px;
    }
  }
}
</style>
